<template>
  <div>
    <PageHeader title="Security" showBack />
    <div class="card p-4">
      <h6 class="mb-3">Change Password</h6>
      <b-form @submit.prevent="handleChangePassword">
        <b-form-group label="Current Password" label-class="form-label">
          <b-form-input v-model="form.current_password" type="password" placeholder="Current password" required />
        </b-form-group>
        <b-row>
          <b-col md="6">
            <b-form-group label="New Password" label-class="form-label">
              <b-form-input v-model="form.new_password" type="password" placeholder="New password" required />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Confirm New Password" label-class="form-label">
              <b-form-input v-model="form.confirm_password" type="password" placeholder="Confirm new password" required />
            </b-form-group>
          </b-col>
        </b-row>
        <b-button type="submit" variant="primary" :disabled="isSaving">{{ isSaving ? 'Updating...' : 'Update Password' }}</b-button>
      </b-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PageHeader from '../../components/Ui/PageHeader.vue';

export default {
  name: 'Security',
  components: { PageHeader },
  data() {
    return {
      form: { current_password: '', new_password: '', confirm_password: '' },
      isSaving: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['getLoggedInUser']),
  },
  methods: {
    async handleChangePassword() {
      if (this.form.new_password !== this.form.confirm_password) {
        this.makeToast('danger', 'Passwords do not match');
        return;
      }
      this.isSaving = true;
      try {
        const userId = this.getLoggedInUser.id;
        await this.$store.dispatch('user/updateUser', {
          id: userId,
          data: { password: this.form.new_password },
        });
        this.makeToast('success', 'Password updated');
        this.form = { current_password: '', new_password: '', confirm_password: '' };
      } catch (err) {
        this.makeToast('danger', 'Failed to update password');
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>
